// Service order statuses.
//
// This file holds NO status ids: they are DB rows (`service_order_status`) and a
// hand-written copy is exactly what went stale on the catalog side (COMY1-283).
// The names below are the vocabulary; ids come from the backend at runtime via
// `supplier/jobs/order-statuses`.

import { apiGetRequest } from "../Helpers/Requests";
import endpoints from "../Helpers/Endpoints";

export const SERVICE_STATUS = {
  DRAFT: "DRAFT",
  WAITING_FOR_SUPPLIER: "WAITING_FOR_SUPPLIER",
  SUPPLIER_FOUND: "SUPPLIER_FOUND",
  WAITING_MEMBER_APPROVAL: "WAITING_MEMBER_APPROVAL",
  WAITING_FOR_PAYMENT: "WAITING_FOR_PAYMENT",
  PAYMENT_DONE: "PAYMENT_DONE",
  CLOSED: "CLOSED",
  CANCELED_BY_MEMBER: "CANCELED_BY_MEMBER",
  CANCELED_BY_SUPPLIER: "CANCELED_BY_SUPPLIER",
};

// Statuses that put a service order in the supplier's Completed filter. The job
// is done for them the moment the member pays (PAYMENT_DONE); CLOSED only comes
// later, when the member fills in the feedback survey — which changes nothing on
// the supplier's side, so a move within this set needs no refetch.
export const DONE_SERVICE_STATUS_NAMES = [
  SERVICE_STATUS.PAYMENT_DONE,
  SERVICE_STATUS.CLOSED,
];

// ── Runtime id ⇄ name map, fetched once ─────────────────────────────────────

let statusMapCache = null;

/**
 * Load the service-order status lookup from the backend. Cached, so every
 * caller shares one request; a failure clears the cache so a later render can
 * retry instead of being stuck with an empty map.
 */
export const loadServiceStatusMap = () => {
  if (!statusMapCache) {
    statusMapCache = apiGetRequest(endpoints.getOrderStatuses())
      .then((resp) => {
        const rows = resp?.data?.data || [];
        return rows.reduce(
          (acc, row) => {
            acc.idByName[row.status] = row.id;
            acc.nameById[row.id] = row.status;
            return acc;
          },
          { idByName: {}, nameById: {} },
        );
      })
      .catch((err) => {
        console.error("Failed to load service order statuses", err);
        statusMapCache = null;
        return { idByName: {}, nameById: {} };
      });
  }
  return statusMapCache;
};
